import React, { useEffect } from "react";
import { ReptoolModal } from "../../utilities/ReptoolModal.tsx";
import { Pairing } from "../../collection/types/CollectionTypes.ts";
import { Pairings } from "../../family_tree/Pairings.tsx";
import { useRepToolContext } from "../../../RepToolContext.tsx";

export const ChoosePairingModal = ({ closeModal, onSelect }: {
  closeModal: () => void;
  onSelect: (pairing: Pairing) => void;
}) => {
  const { appendControls } = useRepToolContext();
  useEffect(() => {
    appendControls(null);
  }, []);

  return <ReptoolModal
    title="Choose Pairing"
    id='choose-pairing-modal'
    closeModal={closeModal}
    body={
      <Pairings refetchPairings={false} onSelect={onSelect} />
    } />
}